import { render, staticRenderFns } from "./convert-lead-form.vue?vue&type=template&id=39ba2484&"
import script from "./convert-lead-form.vue?vue&type=script&lang=js&"
export * from "./convert-lead-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports